













// @ is an alias to /src
import { AloPlat, getDefaultAloPlat } from '@/models/alo/AloPlat'
import { Component, Vue, Watch } from 'vue-property-decorator'
import {ItemPanier} from '@/models/alo/ItemPanier'
import { AloArbo, getDefaultAloArbo } from '@/models/alo/AloArbo'
import { groupByNumber } from '@/utils/groupBy'
import cloneDeep from 'clone-deep'
import PlatEditable from './PlatEditable'
import { AloArboLg } from '@/models/alo/AloArboLg'

@Component({
  name: 'EditPlat',  
  props: {
    show:{
      type:Boolean,
      default:false
    }
  }
})
export default class EditPlat extends Vue {
    
  show!:boolean    
  value!:ItemPanier
  item = new ItemPanier()

  edit(itemPanier:ItemPanier){
    this.item = new ItemPanier(JSON.parse(JSON.stringify(itemPanier)))    
    this.item.uuid = itemPanier.uuid
    this.$nextTick(()=>{
      (this.$refs.editplat as PlatEditable).edit(this.item)
    })    
  }
 
  get showDialog(){    
    return this.show
  }

  set showDialog(value) {
    this.$emit("update:show",value)
  } 

  cancel() {
    this.showDialog = false
  }

  valid() {
    this.$emit("udpateCartItem",this.item)
    this.showDialog = false
  }

  canAddFromArbo(arbo:AloArbo){
    return true
  }

}
